import antd from 'ant-design-vue/es/locale-provider/zh_CN'
import momentCN from 'moment/locale/zh-cn'
import dashboard from './zh-CN/dashboard'

const components = {
  antLocale: antd,
  momentName: 'zh-cn',
  momentLocale: momentCN
}

export default {
  message: '-',
  ...components,
  ...dashboard
}



// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN.js